import { render, staticRenderFns } from "./investcard.vue?vue&type=template&id=eb5a38be&scoped=true"
import script from "./investcard.vue?vue&type=script&lang=js"
export * from "./investcard.vue?vue&type=script&lang=js"
import style0 from "./investcard.vue?vue&type=style&index=0&id=eb5a38be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5a38be",
  null
  
)

export default component.exports